<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box">
            <div class="column is-5">
                <b-field>
                    <b-input :placeholder="$t('CONTASPAGARLISTAR.TITULO')"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column">
                <div class="is-flex is-justified-between">
                    <router-link
                        v-if="isInRole('pagar-alterar')"
                        :to="{ name: 'contaspagar' }"
                        class="button is-primary"
                        >
                        {{$t('CONTASPAGARLISTAR.INCLUIR')}}
                    </router-link>
                </div>                
            </div>           
            <div class="column is-2">
                <form @submit.prevent="abrirCadastroInput">
                    <b-field>
                        <b-input :placeholder="$t('CONTASPAGARLISTAR.CODIGO')"
                                 v-model="id"
                                 type="text"
                                 icon-right="edit"
                                 icon-right-clickable
                                 @icon-right-click="abrirCadastroInput">
                        </b-input>
                    </b-field>
                </form>
            </div>
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 paginated
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 :aria-next-label="$t('CONTASPAGARLISTAR.PROXPAGINA')"
                 :aria-previous-label="$t('CONTASPAGARLISTAR.PAGANTERIOR')"
                 :aria-page-label="$t('CONTASPAGARLISTAR.PAGINA')"
                 :aria-current-label="$t('CONTASPAGARLISTAR.PAGATUAL')"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"
                 @sort="onSort">

            <template @click="abrirCadastro(props.row.id)">
                <b-table-column v-slot="props" field="id" :label="$t('CONTASPAGARLISTAR.ID')" sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column v-slot="props" field="Data" :label="$t('CONTASPAGARLISTAR.DATA')" sortable>
                    {{ $moment(props.row.data).format("DD/MM/YYYY") }}
                </b-table-column>
                <b-table-column v-slot="props" field="Descricao" :label="$t('CONTASPAGARLISTAR.DESCRICAO')" sortable>
                    {{ props.row.descricao }}
                </b-table-column>
                <b-table-column v-slot="props" field="Pedido" :label="$t('CONTASPAGARLISTAR.PEDIDO')">
                    {{ props.row.pedido.descricao }}
                </b-table-column>
                <b-table-column v-slot="props" field="Fornecedor" :label="$t('CONTASPAGARLISTAR.FORNECEDOR')">
                    {{ props.row.fornecedor.nome }}
                </b-table-column>
                <b-table-column v-slot="props" field="Categoria financeira" :label="$t('CONTASPAGARLISTAR.CATEGORIAFINANCEIRA')">
                    {{ props.row.categoriaFinanceira.nome }}
                </b-table-column>
                <b-table-column v-slot="props" field="Vencimento" :label="$t('CONTASPAGARLISTAR.VENCIMENTO')" sortable>
                    <span v-if="props.row.dataDeVencimento">
                        {{ $moment(props.row.dataDeVencimento).format("DD/MM/YYYY") }}
                    </span>
                </b-table-column>
                <b-table-column v-slot="props" field="Valor" :label="$t('CONTASPAGARLISTAR.VALOR')">
                    {{ props.row.valor | currency }}
                </b-table-column>
                <b-table-column v-slot="props" field="Parcela" :label="$t('CONTASPAGARLISTAR.PARCELAS')">
                    {{ props.row.qdteParcelaPaga }} / {{ props.row.qdteParcela }}
                </b-table-column>              
                <b-table-column v-slot="props" field="Cancelada" label="">
                    <b-icon v-if="props.row.cancelada" type="is-danger" icon="close-circle" title="Cancelada"></b-icon>
                </b-table-column>                

                <b-table-column v-slot="props" custom-key="actions" numeric>
                    <router-link :to="{ name: 'contaspagar', params: { id: props.row.id }}" class="button is-small is-primary" title="Editar">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>
            </template>
        </b-table>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex'
    import titlebar from '@/components/titlebar.vue'
import periodoHoraVue from '../../components/periodoHora.vue'

    export default {
        data() {
            return {
                model: {
                parcelas:[],
            },
                total: 0,
                loading: false,
                procurar: this.$route.query.procurar ?? '',
                ordenarPor: 'Data',
                ordenar: 'desc',
                defaultOrdenar: 'desc',
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null,
            }
        },
        components: {
            titlebar
        },
        computed: {
            titleStack() {
                return [
                    this.$t('SIDEBAR.FINANCEIRO'),
                    this.$t('CONTASPAGARLISTAR.TITULO')
                ]
            },
            ...mapGetters([
                'isInRole'
            ])
        },
        methods: {
           loadAsyncData() {
                const params = [
                    `procurar=${this.procurar}`,
                    `ordem=${this.ordenarPor}.${this.ordenar}`,
                    `page=${this.page}`
                ].join('&')

                this.loading = true
                this.$http.get(`/api/financeiro/listarpagar?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        if (data.lista.length == 0 && this.page > 1) {
                            this.page = 1
                            this.loadAsyncData()
                        }
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                        this.$router.replace({query: {procurar: this.procurar, page: this.page }})
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
            abrirCadastro() {
                this.$router.push({ path: `/financeiro/pagar/${this.selecionado.id}` })
            },
            abrirCadastroInput() {
                this.$router.push({ path: `/financeiro/pagar/${this.id}` })
            },
        },
        mounted() {
            this.loadAsyncData()
        }
    }
</script>